import { Product } from './';
import { PlacementType } from './PlacementType';

export interface PlacementTypeProduct extends Product {
  placementType: PlacementType;
}
